<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="mod-joylearning__immuneuser}">
      <el-form label-width="160px"
               label-position="right"
               :model="dataForm"
               :rules="rules">
        <el-row>
          <el-col :span="24">
            <!-- <el-form-item class="grid-content bg-blue"
                          style="margin-left: 10px;">
              <div style="float: left;color: #FFFFFF;margin-top: 2px;">
                {{$t('assign.offeringdetail')}}
              </div>
            </el-form-item> -->
            <div class="el-form-item grid-content bg-blue el-form-item--default"
                 style="margin-left: 10px;">
              <!---->
              <div class="el-form-item__content"
                   style="margin-left: 10px;">
                <div style="float: left; color: rgb(255, 255, 255); margin-top: 2px;">
                    {{$t('assign.immune')}}
                </div>
                <!---->
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <!-- 课程 -->
            <el-form-item :label="$t('assign.course')"
                          prop="courseName">
              {{dataForm.courseName}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <!-- 排期编号 -->
            <el-form-item label="排期编号:"
                          prop="actNumber">
              <!-- 字段值的拼接 用/分隔 -->
              {{dataForm.offeringNo}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="开始时间-结束时间:"
                        prop="startDate">
            {{formatDate(dataForm.startDate)}} - {{formatDate(dataForm.endDate)}}
            <!-- <el-col :span="5">
              {{dataForm.startDate}}
            </el-col>
            <el-col class="line"
                    :span="1">-</el-col>
            <el-col :span="5">
              {{dataForm.endDate}}
            </el-col> -->
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <!-- 地点 -->
            <el-form-item :label="$t('assign.site')"
                          prop="dataForm.cityName">
              {{dataForm.cityName}}{{dataForm.siteName}}
            </el-form-item>
          </el-col>
        </el-row>
          <el-row>
              <el-col :span="24">
                  <!-- 学员 -->
                  <el-form-item :label="$t('assign.learner')"
                                prop="dataForm.userName">
                      {{dataForm.userCode}}-{{dataForm.userName}}
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="20">
                  <!-- 报名时所属公司 -->
                  <el-form-item :label="$t('assign.registeAbbreviationAn')"
                                prop="dataForm.registeAbbreviationCn">
                    {{dataForm.registeAbbreviationCn}}
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row v-if="queryParam.approvalStatus === '40'">
              <el-col :span="24">
                  <!-- 撤销操作人 -->
                  <el-form-item label="撤销操作人:"
                                prop="dataForm.userName">
                      {{dataForm.revokeUserCode}}-{{dataForm.revokeUserName}}
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="24">
                  <!-- 扣款金额 -->
                  <el-form-item label="扣款金额(元):">
                      {{ Number(dataForm.immuneAmount)
                          .toFixed(2)
                          .toString()
                          .replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,")}}
                  </el-form-item>
              </el-col>
          </el-row>
        <el-row>
          <el-col :span="24">
            <div class="el-form-item grid-content bg-gray el-form-item--default"
                 style="margin-left: 10px;">
              <!---->
              <div class="el-form-item__content"
                   style="margin-left: 10px;">
                <div style="margin-top: 2px;">
                  {{$t('assign.immuneInfo')}}
                </div>
                <!---->
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <!-- 免除金额 -->
            <el-form-item label="免除金额(元):"
                          prop="userName">
              {{ Number(dataForm.immuneAmount)
                    .toFixed(2)
                    .toString()
                    .replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,")}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <!-- 免除操作人 -->
            <el-form-item label="免除操作人:">
              {{ dataForm.cancelUserCode}}-{{ dataForm.cancelUserName}}
            </el-form-item>
          </el-col>
        </el-row>
          <el-row>
              <el-col :span="24">
                  <!-- 免除操作时间 -->
                  <el-form-item label="免除操作时间:"
                                prop="immuneDate">
                      {{ dataForm.immuneDate}}
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="24">
                  <!-- 免除原因 -->
                  <el-form-item label="免除原因:"
                                prop="immuneDate">
                      {{ dataForm.immuneReasonFlag}}
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="24">
                  <!-- 备注 -->
                  <el-form-item label=""
                                prop="immuneDate">
<!--                    <div v-html="dataForm.immuneRemark"></div>-->
                    <el-input
                      type="textarea"
                      :disabled="true"
                      :rows="4"
                      placeholder="请输入内容"
                      v-model="dataForm.immuneRemark">
                    </el-input>
                  </el-form-item>
              </el-col>
          </el-row>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import ZElButton from '../../common/button/index'
export default {
  components: { ZElButton },
  data () {
    return {
      immunereasonArr: this.enums['immuneReasonType'],
      txtrevokeRemark: '',
      registeId: '',
      queryParam: {},
      dataList: [],
      dataForm: {
          immuneRemark: '',
          immuneReasonFlag: '',
          immuneUserId:'',
          immuneAmount:'',
          immuneUserName:'',
          immuneDate:'',
          registeNscNo:'',
          registeBbaNo:'',
          registeAbbreviationCn:'',
          registeAbbreviation:'',
        courseName: '',
        actNumber: '',
        maxNumber: '',
        startDate: '',
        endDate: '',
        cityName: '',
        siteName: '',
        fineInformationDTOS: [],
        userName: '',
          userCode: '',
        revokeUserCode: '',
        revokeUserName: '',
        revokeRemark: '',
        revokeReasonFlag: '',
        isNoPenalty: '', // 是否收取撤销罚款，勾选为不收取
        isNoMail: '', // 是否发送撤销电子邮件，勾选为不发送
        isPenalty: '',
        isTa: '',
        offeringNo: ''
        // registeId: this.queryParam.registeId,
        // userId: this.queryParam.userId,
        // offeringId: this.queryParam.offeringId
      },
      checkedPenalty: false, // 用于是否收取撤销罚款的checkbox 标识是否勾选 v-model的值
      checkedMail: false, // 用于是否发送撤销罚款电子邮件的checkbox 标识是否勾选 v-model的值
      isShow: false,
      showCheck: false,
      showCheckUser: false,
      revokereasonArr: this.enums['cancelReasons'],
      // 编辑面板的验证规则
      rules: {
        revokeReasonFlag: [{ required: true, message: '请选择撤销原因', trigger: 'blur' }]
      },
      commitLoading: false
    }
  },
  activated () {
    this.immuneInfo()
  },

  methods: {
    immuneInfo() {
      this.queryParam.approvalStatus = this.$route.query.approvalStatus
      this.$request.post('/learning/penaltyrevokehistory/immune', {
        registeId: this.$route.query.registeId,
        userId: this.$route.query.userId,
        offeringId: this.$route.query.offeringId
      })
        .then((res, total, code, data) => {
          this.dataForm.immuneDate = data.data.immuneDate
          console.log(this.dataForm.immuneDate)
          this.dataForm.immuneUserName = data.data.cancelUserName
          this.dataForm.immuneUserId = data.data.cancelUserId
          this.dataForm.immuneAmount = data.data.penaltyAmount
          for (let i = 0; i < this.immunereasonArr.length; i++) {
            if (this.immunereasonArr[i].code === data.data.immuneReasonFlag) {
              this.dataForm.immuneReasonFlag = this.immunereasonArr[i].name
            }
          }
          this.dataForm.immuneRemark = data.data.immuneRemark

          // 撤销
          this.dataForm.revokeUserCode = data.data.revokeUserCode
          this.dataForm.revokeUserName = data.data.revokeUserName
          // 免除
          this.dataForm.cancelUserCode = data.data.cancelUserCode
          this.dataForm.cancelUserName = data.data.cancelUserName
          this.dataForm.registeNscNo = data.data.registeNscNo
          this.dataForm.registeBbaNo = data.data.registeBbaNo
          this.dataForm.registeAbbreviation = data.data.registeAbbreviation

          if(data.data.registeBbaNo === '' || data.data.registeBbaNo === undefined || data.data.registeBbaNo === null){
            this.dataForm.registeAbbreviationCn = this.dataForm.registeAbbreviation
          }else {
            this.dataForm.registeAbbreviationCn = this.dataForm.registeBbaNo + '_' + this.dataForm.registeNscNo + '_' + this.dataForm.registeAbbreviation
          }

          this.dataForm.courseName = data.data.courseName
          this.dataForm.startDate = data.data.offeringStartDate
          this.dataForm.endDate = data.data.offeringEndDate
          this.dataForm.siteName = data.data.siteName
          this.dataForm.userName = data.data.userName
          this.dataForm.userCode = data.data.userCode

          this.dataForm.offeringNo = data.data.offeringNo


          console.log(this.immunereasonArr)
          console.log('this.dataForm')
          console.log(this.dataForm)
        })
    },
    formatDate (startdate) {
      if (startdate === null || startdate === '' || startdate === undefined) {
        return ''
      }
      if (startdate.indexOf('.') > -1) {
        startdate = startdate.replace('.0', '')
      }
      let startdataMM = new Date(startdate.replace(/-/g, "/"))
      let year = startdataMM.getFullYear()
      let month = startdataMM.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      let date = startdataMM.getDate()
      if (date < 10) {
        date = '0' + date
      }
      let hours = startdataMM.getHours()
      if (hours < 10) {
        hours = '0' + hours
      }
      let minutes = startdataMM.getMinutes()
      if (minutes < 10) {
        minutes = '0' + minutes
      }

      let startdatadd = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes
      return startdatadd
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        item => item.name !== tabName
      )
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName =
          'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    }
  },
    // 千分位
    numberToCurrencyNo(value) {
        if (!value) return 0
        // 获取整数部分
        const intPart = Math.trunc(value)
        // 整数部分处理，增加,
        const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        // 预定义小数部分
        let floatPart = ''
        // 将数值截取为小数部分和整数部分
        const valueArray = value.toString().split('.')
        if (valueArray.length === 2) { // 有小数部分
            floatPart = valueArray[1].toString() // 取得小数部分
            return intPartFormat + '.' + floatPart
        }
        return intPartFormat + floatPart
    }
}
</script>
<style>
.bg-gray {
  background: #dcdcdc;
}
.bg-blue {
  background: #1c69d3;
}
.grid-content {
  border-radius: 4px;
  min-height: 30px;
}
.search {
  margin-bottom: 10px;
}
.timeRange1 .element.style {
  margin-left: 10px;
}
.el-form-item__content .textarea_class_deal .el-input__count {
  position: initial;
  float: right;
}
</style>
